import React from 'react';
import Button from './Button';

const feeRows = [
  { category: 'IASG Member or Faculty', till20March: '₹ 2500', beyond20March: '₹ 3000' },
  { category: 'IASG Non Member', till20March: '₹ 3000', beyond20March: '₹ 3500' },
  { category: 'PG Student', till20March: '₹ 1500', beyond20March: '₹ 3000' },
  { category: 'Spouse', till20March: '₹ 2000', beyond20March: '₹ 2000' },
];

function RegistrationSection() {
  return (
    <section id="registration" className="section registration-section">
      <div className="container">
        <h2 className="speakers-title">Registration Details</h2>
        <div className="registration-table-wrap">
          <table className="registration-table">
            <thead>
              <tr>
                <th scope="col">Category</th>
                <th scope="col">Till 20 March 2026</th>
                <th scope="col">Beyond 20 March 2026 or on the Spot</th>
              </tr>
            </thead>
            <tbody>
              {feeRows.map((row) => (
                <tr key={row.category}>
                  <th scope="row">{row.category}</th>
                  <td>{row.till20March}</td>
                  <td>{row.beyond20March}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="registration-note">
          Note: No Guarantee of Conference Kit and Bag. Subject to availability for on-spot Registration.
        </p>
        <div className="registration-button-wrapper">
          <Button
            variant="primary"
            className="btn btn-secondary"
            // href="#registration"
            iconRight="ri-arrow-right-line"
            onClick={() => {
              window.open("https://iasg.register.enhance.events/midtermconference2026", "_blank");
            }}
          >
            Register Now
          </Button>
        </div>
      </div>
    </section>
  );
}

export default RegistrationSection;
